export const UPDATE_INGREDIENTS = "UPDATE_INGREDIENTS";
export const UPDATE_INGREDIENTS_AND_PRICE = "UPDATE_INGREDIENTS_AND_PRICE";
export const ADD_INGREDIENT = "ADD_INGREDIENT";
export const REMOVE_INGREDIENT = "REMOVE_INGREDIENT";
export const LOAD_INGREDIENTS = "LOAD_INGREDIENTS";
export const ERROR_FOUND = "ERROR_FOUND";

export const STARTED_FORM_POST = "STARTED_FORM_POST";
export const FORM_POST_SUCCESS = "FORM_POST_SUCCESS";
export const FORM_POST_FAILURE = "FORM_POST_FAILURE";
export const LOADING_POSTING_FORM = "LOADING_POSTING_FORM";
export const RESET_BURGUR_PURCHASED_STATUS = "RESET_BURGUR_PURCHASED_STATUS";

export const STARTED_LOADING_ORDERS = "STARTED_LOADING_ORDERS";
export const LOADING_ORDERS_SUCCESS = "LOADING_ORDERS_SUCCESS";
export const LOADING_ORDERS_FAILURE = "LOADING_ORDERS_FAILURE";
export const ORDERS_LOADING = "ORDERS_LOADING";
export const STOP_LOADING = "STOP_LOADING";

export const DELETE_ORDER = "DELETE_ORDER";
export const DELETE_ORDER_LOADING = "DELETE_ORDER_LOADING";
export const DELETE_ORDER_SUCCESS = "DELETE_ORDER_SUCCESS";
export const DELETE_ORDER_FAIL = "DELETE_ORDER_FAIL";

export const AUTH_STARTED = "AUTH_STARTED";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOG_OUT = "AUTH_LOG_OUT";



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js